import gql from 'graphql-tag';

const mutation = gql`
  mutation unsubscribe($email: String!, $tmc: String!, $altcha: String) {
    unsubscribe(input: { email: $email, tmc: $tmc, altcha: $altcha }) {
      result
      success
      message
    }
  }
`;

export default function unsubscribe({ apollo, email, tmc, altcha = null }) {
  return apollo.mutate({
    mutation,
    variables: {
      email,
      tmc,
      altcha
    }
  });
}
